<template>
  <div class="shoppingMall">
        <!-- 内容 -->
        <div class="navContent" :style="styleBox.backgroundColor">
            <!-- returnPage  -->
            <span @click="neirong">
                <i class="iconfont icon-fanhui"></i>
            </span>
            <span>
                积分兑换
            </span>
            <span>

            </span>
        </div>
        <keep-alive>
            <router-view class="shopBox"></router-view>
        </keep-alive>
        <!-- 底部导航 -->
        <shopTabbar></shopTabbar>
  </div>
</template>


<script>
import shopTabbar from "./shopTabbar.vue"
export default {
    components:{
        shopTabbar //底部导航切换
    },
    methods:{
        neirong(){
            this.returnPage();
        }
    }
}
</script>

<style scoped>
    .shopBox{
        width: 100%;
        height: calc(100% - 114px);
    }
    .shoppingMall{
        width: 100%;
        height: 100%;
    }
    .navContent{
        height: 64px;
        padding: 0px 3%;
        padding-top: 24px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        font-size: 16px;
    }
</style>